import React, { useEffect } from 'react'
import { makeStyles } from "@material-ui/core/styles";
import { Container, Grid } from "@material-ui/core";
import { ReactComponent as AutorizacionesIcon } from './../../../assets/icons/iconoAutorizacionesGris.svg';
import { ReactComponent as CredencialIcon } from './../../../assets/icons/iconoCredencial.svg';
import CardHome from "./CardHome";
import { getCredenciales } from "../../../actions/webAfiliado/afiliadoVariosAction";
import { ReactComponent as TurnosIcon } from './../../../assets/icons/iconoTurnos.svg';
import { ReactComponent as ContactosIcon } from './../../../assets/icons/iconoContactos.svg';
import { ReactComponent as CartillaIcon } from './../../../assets/icons/iconoCartillaGris.svg';
import { ReactComponent as FarmaciasIcon } from './../../../assets/icons/iconoFarmacias.svg';
import { ReactComponent as FormulariosIcon } from './../../../assets/icons/iconoFormularios.svg';
import { ReactComponent as HistoriaIcon } from './../../../assets/icons/iconoHistoriaGris.svg';
import { ReactComponent as ReintegrosIcon } from './../../../assets/icons/iconoReintegrosGris.svg';
import { ReactComponent as FacturacionIcon } from './../../../assets/icons/Icono-facturacion-final.svg';
import { ReactComponent as DiscapacidadIcon } from './../../../assets/icons/iconoDiscapacidad.svg';

import { useDispatch } from "react-redux";
import { cargarEstadisticas } from "../../../actions/miOspedyc/estadisticasMiOspedyc";
import { ESTADISTICAS_OSPEDYC } from "../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100%',
    marginTop: "1rem",
    marginBottom: "1rem"
  },
  icon: {
    color: "primary"
  }
}));

export const HomeAfiliado = (props) => {

  const classes = useStyles();
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCredenciales())
  }, [dispatch]);

  return (
    <div className={classes.root}>
      <Container maxWidth="md">
        <Grid
          container
          direction="row"
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={4} style={{ height: "100%" }}>
            <CardHome title={"Credencial digital"} Icon={CredencialIcon} route={"/afiliado/credenciales"} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Turnos"} Icon={TurnosIcon} route={"/afiliado/turnos"} />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome
              title={"Cartilla médica"}
              Icon={CartillaIcon}
              route={process.env.REACT_APP_ENVIRONMENT === 'production' ? "https://www.ospedyc.org.ar/beneficiarios/cartillamedica.aspx" : "/afiliado/cartilla"}
              externo={process.env.REACT_APP_ENVIRONMENT === 'production'}
              handleFunction={() => dispatch(cargarEstadisticas(ESTADISTICAS_OSPEDYC.CARTILLA))}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Formularios"} Icon={FormulariosIcon} route="/afiliado/formularios" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Empadronamientos"} Icon={HistoriaIcon} route="" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Autorizaciones"} Icon={AutorizacionesIcon} route="" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Facturas"} Icon={FacturacionIcon} route="/afiliado/facturas" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Farmacias"} Icon={FarmaciasIcon} route="/afiliado/farmacias" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Reintegros"} Icon={ReintegrosIcon} route="" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Discapacidad"} Icon={DiscapacidadIcon} route="/afiliado/discapacidad" />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <CardHome title={"Contactos"} Icon={ContactosIcon} route="/afiliado/contactos" />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};
